import React, {Component} from 'react';

import {IconMoreVertical} from "@amzn/stencil-react-components/icons";
import {PageHeaderDropdownButton} from "@amzn/stencil-react-components/page";
import {Popover} from "@amzn/stencil-react-components/popover";

export class RowActionMenu extends Component {

  render() {
    const { title, menuItems } = this.props;

    return (
      <Popover
        dataTestId={'award-row-menu_' + title}
        triggerText=""
        triggerButtonProps={{
          iconAltText: "Action Button Icon for " + title,
          icon: <IconMoreVertical title={"Actions for " + title} />
        }}
      >
        {() => (
          menuItems.map((item, index) => (
            <PageHeaderDropdownButton
              aria-label={`${item.label}`}
              key={index}
              onClick={() => this.props.onMenuItemClick(item.value)}
            >
              {item.label}
            </PageHeaderDropdownButton>
          ))
        )}
      </Popover>
    )
  }
}
